import { FC, Fragment, useContext } from "react";
import { EDocumentCategory } from "../../content/types";
import { Grid, Link, Typography } from "@mui/material";
import { StandardDocumentsWidget } from "./standard-category-widget";
import { WeightDocumentsWidget } from "./weight-document-widget/weight-documents-widget";
import { useParams } from "react-router-dom";
import { UserProgramContext } from "../../context/user-program/user-program";
import { assertNonNullable } from "../../utils/asserts";
import { DOCUMENTS_CATEGORIES } from "../constants";
import { ContainedButton } from "../styled/contained-button";

export const SectionDocuments: FC<object> = () => {
  const { title: sectionTitle } = useParams();

  const { program } = useContext(UserProgramContext);

  const sectionWithoutAllCategories = ["Sport"];

  const categoriesNamesForSpecialDocuments = [
    "approval",
    "medicalCetificateOfNecessity",
  ];

  assertNonNullable(program);

  const categories =
    program.sections.find((section) => section.title === sectionTitle)
      ?.documentCategories || [];

  if (!sectionTitle || !categories) {
    return null;
  }

  const shouldDisplayCategory = (category: string) => {
    return (
      sectionWithoutAllCategories.includes(sectionTitle) &&
      categoriesNamesForSpecialDocuments.includes(category)
    );
  };

  return (
    <Fragment>
      {/* info section */}
      {sectionTitle !== "Sport" && (
        <>
          <Typography mt={2} variant="body2">
            Liebe Patientinnen und Patienten,
          </Typography>
          <Typography mt={2} variant="body2">
            Für das MMK-Programm vor Ihrer Magen-OP gibt es ein paar Dinge, die
            Sie vorbereiten müssen:
          </Typography>
          {categories.map((category, index) => {
            const documentCategoryInfo = DOCUMENTS_CATEGORIES[category];

            if (!documentCategoryInfo) {
              return null;
            }

            return (
              !shouldDisplayCategory(category) && (
                <Fragment key={category}>
                  <Typography
                    mt={2}
                    variant="h6"
                    sx={{ textDecoration: "underline" }}
                  >
                    {index + 1}. {documentCategoryInfo.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    dangerouslySetInnerHTML={{
                      __html: documentCategoryInfo.description,
                    }}
                  ></Typography>
                </Fragment>
              )
            );
          })}
          <Fragment>
            <Typography
              mt={2}
              variant="h6"
              sx={{ textDecoration: "underline" }}
            >
              Download
            </Typography>
            <Typography variant="body2" paragraph>
              <strong>Wie?</strong> Klicken Sie auf „Vorlage Sportprotokoll
              herunterladen" und laden Sie die Vorlage herunter. Drucken Sie die
              Vorlage aus oder füllen Sie diese digital aus. Schreiben Sie auf,
              wann und welchen Sport Sie machen. Füllen Sie das Dokument
              vollständig aus. Lassen Sie Ihre/n Partner/in, einen Verwandten
              oder einen Freund unterschreiben.
            </Typography>
            <Typography variant="body2" sx={{ mb: 4 }}>
              <strong>Dann?</strong> Machen Sie von dem vollständig ausgefüllten
              Protokoll ein Foto oder einen Scan und laden Sie es am Ende Ihrer
              Therapielaufzeit hier hoch.
            </Typography>
          </Fragment>
        </>
      )}

      <Grid container spacing={3} mb={3}>
        {categories.map((category) => {
          const documentCategoryInfo = DOCUMENTS_CATEGORIES[category];

          if (!documentCategoryInfo.exampleDownloadLink) {
            return null;
          }

          return (
            <Grid item key={category}>
              {
                <>
                  {!shouldDisplayCategory(category) && (
                    <div>
                      <form method="get" action="file.doc"></form>
                      <Link
                        href={documentCategoryInfo.exampleDownloadLink}
                        download={`Vorlage ${documentCategoryInfo.title}`}
                        target="_blank"
                      >
                        <ContainedButton>
                          Vorlage {documentCategoryInfo.title} herunterladen
                        </ContainedButton>
                      </Link>
                    </div>
                  )}
                </>
              }
            </Grid>
          );
        })}
      </Grid>

      {/* documents upload section */}
      <Grid container spacing={3}>
        {Array.from(categories).map((category) => {
          return (
            <Fragment key={category}>
              {category === EDocumentCategory.WEIGHT_DATA && (
                <Grid item xs={12} md={6} xl={4}>
                  <WeightDocumentsWidget sectionTitle={sectionTitle} />
                </Grid>
              )}

              {category !== EDocumentCategory.WEIGHT_DATA &&
                !shouldDisplayCategory(category) && (
                  <Grid item xs={12} md={6} xl={4}>
                    <StandardDocumentsWidget
                      category={category}
                      sectionTitle={sectionTitle}
                    />
                  </Grid>
                )}
            </Fragment>
          );
        })}
      </Grid>
    </Fragment>
  );
};
